import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSummary: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="summary, summarize"><path d="M3.75 5.75V17.25H17.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M18 18.75V15.75L20 17.25L18 18.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.25 7.25H16.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.25 12.25H13.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSummary;
